<template>
  <div id="jumbotron">
    <div class="container">
      <h1>Creative Writing Class<br>  for Ages 5 to 17</h1>
    </div>
  </div>

  <div class="container pt-5">
    <h2 class="text-primary">Write Your Own Adventure with Our Creative Writing Class!</h2>
    <div class="yt-container">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/nw3kjL0QrWw?si=LennlpPcc1efLPk4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
  </div>

  <div class="container py-5">
    <div class="row m-0">
      <div class="col-12 col-md-6 text-center">
        <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/Classes+Creative+Writing.webp"
            alt="Creative Writing Class" class="w-100">
      </div>
      <div id="description" class="col-12 col-md-6">
        <p>Great English doesn’t mean great writing skills!</p>
  
        <p>Did you know only 1 in 3 kids enjoy writing? As they grow, this number drops even more—especially with AI on the rise. 🧠✨</p>
  
        <p>At English Matters in Petaling Jaya, we’re not just about language skills; we’re about nurturing the next generation of writers, poets, and storytellers. If your child dreams of becoming a journalist, producer, social media influencer, content creator or author, our Creative Writing classes are where they need to be. </p>
  
        <p>Don’t let their creativity fade. Let’s inspire the writer within!</p>
      </div>
    </div>
  </div>
  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; max-width: 900px; margin: auto; }

.yt-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 aspect ratio (height = width * 9/16) */
}

.yt-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

img {
  max-width: 450px;
  margin: auto;
  text-align: center;
}

#description {
  font-size: 1.4em;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>